export function download(title, blob) {
  const url = URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', title);
  document.body.appendChild(link);
  link.click();
  link.remove();
}
